import { FC, useRef, useState} from "react"
import { AgGridColumn, AgGridReact } from "ag-grid-react"
import '../../../../ag-grid.css'
import '../../../../ag-theme-alpine.css'
import { warning } from "../../../../utils/notifications"
import {TfiComment} from 'react-icons/tfi'
import { Tooltip } from "primereact/tooltip"
import { Avatar } from 'primereact/avatar';
import { EditEntregasModalDialog } from "./EditEntregasModalDialog/EditEntregasModalDialog"
import { ParadaPlantaModal } from "./ParadaPlantaModal/ParadaPlantaModal"
import { AcopioModal } from "./AcopioModal/AcopioModal"
import moment from "moment"
import { defaultRenderer, generateUserColor, numberFormatter } from "../../../../utils/helperFunctions"

export const EntregasTable:FC<any> = (props) => {

    const gridRef :any= useRef();

    const { data, setData, dataMASTER, saveLoading, openPP, setOpenPP, openA, setOpenA, changesFlag, setChangesFlag, id, flagChangeScenario, setFlagChangeScenario, tabID } = props

    const [ visible, setVisible ] = useState<boolean>(false)

    const [comentarioEnEdicion, setComentarioEnEdicion] = useState<any>(undefined) 

    const [comentarioEditado, setComentarioEditado] = useState<string>("")

    const [ selectedCell, setSelectedCell ] = useState<any>()

    const [ selectedRow, setSelectedRow ] = useState<any>()

    const [ mode, setMode] = useState<string>("")

    const [ type, setType ] = useState<string>("PKM")

    const [newComment, setNewComment] = useState<string>("")

    const [justComment, setJustComment] = useState<boolean>(false)

    const spanRef:any = useRef(null);

    const onGridReady = (params:any) => {  
        const currentWeekNumber = moment().isoWeek();
        gridRef?.current?.api?.ensureColumnVisible(`w${currentWeekNumber}`,'middle')  
    }

    const handleClose = () => {
        setSelectedCell(undefined)
        setSelectedRow(undefined)
        setComentarioEnEdicion(undefined)
        setComentarioEditado("")
        setVisible(false)
        setNewComment("")
        setMode("")
        
    }

    const handleClosePP = () => {
        setOpenPP(false)
        setMode("")
    }

    const handleCloseA = () => {
        setOpenA(false)
        setMode("")
    }

   
    const handleCellStyleP = (params:any) => {
        
            return {backgroundColor: 'transparent',color: 'black',fontWeight:'normal',height:'100%',border:'1px solid #dee2e6'}
        
    }


    const commentCellRenderer = (params:any) => {
        
        const {colId} = params.column
        let renderized_popup:any;
        if(`comment_${colId}` in params.data) {
            renderized_popup = 
            <div>
                <span style={{borderBottom:'1px solid black',marginBottom:5, fontWeight:'bold'}}>Comentarios - {params.colDef.headerName} </span>
                <div style={{overflowY:'auto',height:200,paddingTop:'0.5rem'}}>
                    {params.data[`comment_${colId}`].map((comm:any) => {
                        return(
                            <p key={comm.id_comentario} style={{display:'flex',justifyContent:'flex-start',alignItems:'center'}}>
                                <span style={{display:'flex',justifyContent:'center',alignItems:'center'}}><Avatar label={comm.avatar} style={{ backgroundColor: generateUserColor(comm.id_user), color: '#ffffff', marginRight:'5px', fontSize:'0.75rem',minWidth:33 }} shape="circle" /><span>{comm.comentario} - <small><i>{comm.user} {moment(comm.date).format('DD-MM-YYYY HH:mm')}</i></small></span></span>
                            </p>
                        )
                    })}
                </div>
            </div>
        }

        
        
        
        if(`comment_${colId}` in params.data) {
            return(
                <div>
                    <span style={{marginRight:'5px'}}>{numberFormatter(params.value[0])}</span>
                    <TfiComment className={`custom-crazy-icon_${colId}_${params.data.id_proveedor}`}/>
                    <Tooltip autoHide={false}  className="custom-tooltip-comment" target={`.custom-crazy-icon_${colId}_${params.data.id_proveedor}`} >
                        {renderized_popup}
                    </Tooltip>
                </div>
            )  
        } else {
            return(
                <div>
                    <span>{numberFormatter(params.value[0])}</span>
                    
                </div>
            )  
        }
        
    }

    const orderFunc = (row_keys:any) => {
        const nuevoObjeto = Object.fromEntries(
            Object.entries(row_keys).filter(([key, value]) => {
              return !key.startsWith("w") || (Array.isArray(value) && value.length === 3);
            })
          );

        let filtered_keys = Object.keys(nuevoObjeto).filter((key) => key.startsWith("w")).sort((a, b) => {
            const weekA = row_keys[a];
            const weekB = row_keys[b];
            const monthA = weekA[1];
            const yearA = weekA[2];
            const monthB = weekB[1];
            const yearB = weekB[2];
    
            if (yearA !== yearB) {
                return yearA - yearB;
            } else {
                return monthA - monthB || parseInt(a.slice(1)) - parseInt(b.slice(1));
            }
        });
        
        let currentMonth = row_keys[filtered_keys[0]] ? row_keys[filtered_keys[0]][1] : 1;
        let currentYear = row_keys[filtered_keys[0]] ? row_keys[filtered_keys[0]][2] : 1990;
        
        let ordered_keys = filtered_keys.flatMap((row) => {
            const week = row_keys[row];
            const month = week[1];
            const year = week[2];
    
            if (currentMonth === month && currentYear === year) {
                return row;
            } else {
                currentMonth = month === 1 ? 1 : month; // Cambiamos el mes solo si es enero
                currentYear = year;
    
                let arr_keys = [];
                
                if (currentMonth === 1) {
                    // Tratamiento especial para la última semana del año
                    arr_keys.push(`total_entregado_mes_12`);
                    arr_keys.push(`pendiente_mes_12`);
                } else {
                    arr_keys.push(`total_entregado_mes_${currentMonth - 1}`);
                    arr_keys.push(`pendiente_mes_${currentMonth - 1}`);
                }
                arr_keys.push(row);
                return arr_keys;
            }
        });
    
        // Agregamos las columnas totales y pendientes del último mes del último año
        const lastWeek = filtered_keys[filtered_keys.length - 1];
        
        const lastMonth = row_keys[lastWeek] ? row_keys[lastWeek][1] : 1;
    
        if (lastMonth === 0) {
            // Tratamiento especial para la última semana del año
            ordered_keys.push(`total_entregado_mes_12`);
            ordered_keys.push(`pendiente_mes_12`);
        } else {
            ordered_keys.push(`total_entregado_mes_${lastMonth}`);
            ordered_keys.push(`pendiente_mes_${lastMonth}`);
        }

        return ordered_keys
    }

 
    const handleOpenCellModal = (params:any) => {

        let row_keys = params.data

        let ordered_keys = orderFunc(row_keys)

        let lista_numeros = ordered_keys.filter((k:any) => k.startsWith("w")).map((kf:any) => parseInt(kf.length === 2? kf.slice(-1) : kf.slice(-2)))

        let { colId } = params.column
        
        let numero = colId.length === 2? parseInt(colId.slice(-1)) : parseInt(colId.slice(-2))

        var indiceActual = lista_numeros.indexOf(moment().week());
        var indiceSeleccionado = lista_numeros.indexOf(numero);

        if (indiceSeleccionado === -1) {
            console.log("indice")
        } else if (indiceSeleccionado < indiceActual) {
            //warning("No se pueden editar registros anteriores a la semana actual")
            setSelectedCell(colId)
            setSelectedRow(params.data)
            setVisible(true)
            setJustComment(true)
        } else {
            setSelectedCell(colId)
            setSelectedRow(params.data)
            setVisible(true)
            setJustComment(false)
        }
         
    }

    const numberCellRenderer = (params:any) => {
        return numberFormatter(params.value)
    }

    const handleCellStyleFH = (params:any) => {
        
        let original = dataMASTER?.find((ori:any) => ori.id_proveedor === params.data.id_proveedor)?.[params.column.colId]
        
        if(original != params.value) {
            return {backgroundColor: 'orange', color: 'white', fontWeight:'bold',border:'1px solid #dee2e6'}
        } else {
            return {backgroundColor: '#ECECEC',color: 'black',fontWeight:'normal',border:'1px solid #dee2e6'}
        } 
    }

    const handleCellStyle = (params:any) => {
        let original = dataMASTER?.find((ori:any) => ori.id_proveedor === params.data.id_proveedor)?.[params.column.colId][0]
        
        if(original != params.value[0]) {
            return {backgroundColor: 'orange', color: 'white', fontWeight:'bold',border: moment().week() === parseInt(params.column.colId.slice(1)) ? '1px solid aqua' : '1px solid #dee2e6'}
        } else {
            return {backgroundColor: 'transparent',color: 'black',fontWeight:'normal',border: moment().week() === parseInt(params.column.colId.slice(1)) ? '1px solid aqua' : '1px solid #dee2e6'}
        } 
    }

    const handleFirstDataRender = (params:any) => {
        spanRef?.current.click();
    }

    const test = () => {
        const currentWeekNumber = moment().isoWeek();
        gridRef?.current?.api?.ensureColumnVisible(`w${currentWeekNumber}`,'middle')
    }


    const dataTableRender = () => {
        let row_keys = data[0];

        let ordered_keys = orderFunc(row_keys)
    
      
        return ordered_keys.map((row) => {
            let isWeek = moment().week() === parseInt(row.slice(1));
    
            if (row.startsWith('w')) {
                return (
                    <AgGridColumn
                        headerClass={isWeek ? "header-resize current-week" : "header-resize"}
                        cellStyle={handleCellStyle}
                        cellRenderer={commentCellRenderer}
                        sortable
                        width={90}
                        suppressNavigable
                        headerName={row}
                        field={row}
                    ></AgGridColumn>
                );
            } else {
                return (
                    <AgGridColumn
                        headerClass={"header-resize"}
                        cellStyle={{ ...handleCellStyleP, backgroundColor: 'rgba(25, 25, 112, 0.8)', color: 'white' }}
                        cellRenderer={defaultRenderer}
                        resizable
                        sortable
                        width={150}
                        suppressNavigable
                        headerName={row.replace(/_/g, ' ').replace(/\b\w/g, (first) => first.toUpperCase())}
                        field={row}
                    ></AgGridColumn>
                );
            }
        });
    }


    

    return (
        <div className="ag-theme-alpine" style={saveLoading? {display:'flex',flexDirection:'column', height:'100%', width: '99%',opacity:0.6 } : {display:'flex',flexDirection:'column', height:'100%', width: '99%' }}>
            
            <EditEntregasModalDialog
                visible={visible}
                setVisible={setVisible}
                handleClose={handleClose}
                comentarioEnEdicion={comentarioEnEdicion}
                setComentarioEnEdicion={setComentarioEnEdicion}
                comentarioEditado={comentarioEditado}
                setComentarioEditado={setComentarioEditado}
                selectedCell={selectedCell}
                setSelectedCell={setSelectedCell}
                selectedRow={selectedRow}
                setSelectedRow={setSelectedRow}
                mode={mode}
                setMode={setMode}
                dataTable={data}
                dataTableMASTER={dataMASTER}
                setData={setData}
                type={type}   
                setType={setType}
                newComment={newComment}
                setNewComment={setNewComment}
                changesFlag={changesFlag}
                setChangesFlag={setChangesFlag}
                id={id}
                tabID={tabID}
                justComment={justComment}
            />

            <ParadaPlantaModal
                visible={openPP}
                setVisible={setOpenPP}
                handleClose={handleClosePP}
                id={id}
                mode={mode}
                setMode={setMode}
                data={data}
                dataMASTER={dataMASTER}
                setData={setData}
                type={type}   
                flagChangeScenario={flagChangeScenario}
                setFlagChangeScenario={setFlagChangeScenario}
                />

            <AcopioModal
                visible={openA}
                setVisible={setOpenA}
                handleClose={handleCloseA}
                id={id}
                mode={mode}
                setMode={setMode}
                data={data}
                dataMASTER={dataMASTER}
                setData={setData}
                type={type}  
                flagChangeScenario={flagChangeScenario}
                setFlagChangeScenario={setFlagChangeScenario} 
                />
                <span ref={spanRef} onClick={test}></span>
            <AgGridReact
                ref={gridRef}
                onGridReady={onGridReady}
                
                headerHeight={30}
                getRowHeight={() => 30}
                onCellDoubleClicked={handleOpenCellModal}
                rowData={data}
                onFirstDataRendered={handleFirstDataRender}
                enableCellTextSelection
                >
               
                <AgGridColumn sortable   suppressNavigable={true} hide   headerName={"Almacén"} field={"id_proveedor"}></AgGridColumn>

                <AgGridColumn headerClass={"header-border header-resize"} cellStyle={{backgroundColor: '#ECECEC',justifyContent:'flex-start'}} pinned={"left"} sortable filter={true}  width={300} suppressNavigable={true} tooltipField={"name_proveedor"}   headerName={"Proveedor"} field={"name_proveedor"}></AgGridColumn>
                
                <AgGridColumn headerClass={"header-resize"} cellStyle={handleCellStyleFH}  pinned={"left"}  sortable cellRenderer={numberCellRenderer}   width={125} suppressNavigable    headerName="Contratado (Tm)" field="tn_contratada_anio"></AgGridColumn>

                <AgGridColumn headerClass={"header-resize"} cellStyle={handleCellStyleFH}  pinned={"left"}  sortable cellRenderer={numberCellRenderer}  width={120} suppressNavigable    headerName="Entregado (Tm)" field="tn_real_entregada"></AgGridColumn>
                        
                <AgGridColumn headerClass={"header-resize"} cellStyle={handleCellStyleFH}  pinned={"left"}  sortable cellRenderer={numberCellRenderer}  width={120} suppressNavigable    headerName="Planificado (Tm)" field="tn_entregada"></AgGridColumn>
                    
                <AgGridColumn headerClass={"header-resize"} cellStyle={handleCellStyleFH}  pinned={"left"}  sortable width={90}  suppressNavigable  headerName="Viajes" field="viajes"></AgGridColumn>

                {
                    Array.isArray(data)?

                    dataTableRender()

                    :

                    false
                }
                

            </AgGridReact>
        </div>
            
      
    )
}